<template>
  <InputView type="text" :title="title" v-model:value="stringInput" :placeholder="placeholder" :errors="errors" @focus="focused = true" @blur="updateValue(); focused = false" :class="{ 'border-danger': !validInput && !focused }" :required="required">
    <template v-slot:extra>
      <span v-if="displayValue">
        {{ displayValue }}
      </span>
    </template>
  </InputView>
</template>

<script>
import {Duration} from "luxon";
import utilities from "../../../utilities.js";
import InputView from "./InputView.vue";

export default {
  name: "DurationInputView",
  components: {InputView},
  props: {
    required: Boolean,
    value: Number,
    errors: Array,
    title: String,
    locale: String
  },
  emits: ["update:value"],
  data() {
    return {
      validInput: true,
      stringInput: "",
      focused: false,
      daysLetter: undefined,
      hoursLetter: undefined,
      minutesLetter: undefined,
      secondsLetter: undefined,
      letters: undefined,
    }
  },
  mounted() {
    this.daysLetter = new Intl.NumberFormat(this.locale, { style: "unit", unit: "day", unitDisplay: "long" }).format(1)[2];
    this.hoursLetter = new Intl.NumberFormat(this.locale, { style: "unit", unit: "hour", unitDisplay: "long" }).format(1)[2];
    this.minutesLetter = new Intl.NumberFormat(this.locale, { style: "unit", unit: "minute", unitDisplay: "long" }).format(1)[2];
    this.secondsLetter = new Intl.NumberFormat(this.locale, { style: "unit", unit: "second", unitDisplay: "long" }).format(1)[2];
    this.letters = [this.daysLetter, this.hoursLetter, this.minutesLetter, this.secondsLetter];
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.intValue !== this.value) {
          this.stringInput = this.stringValue.trim();
          this.validateInput();
        }
      }
    },
    stringInput() {
      this.validateInput();
      this.updateValue();
    }
  },
  methods: {
    validateInput() {
      if (this.stringInput.length === 0) {
        this.validInput = !this.required;
        return;
      }
      let splitted = this.stringInput.trim().split(" ");
      for (var i = 0; i < splitted.length; i++) {
        let part = splitted[i];
        if (part.length > 0) {
          let unit = part[part.length - 1];
          if (!this.letters.includes(unit) || parseInt(part.substring(0, part.length - 1)) === undefined || !/^\d+$/.test(part.substring(0, part.length - 1))) {
            this.validInput = false;
            return;
          }
        } else {
          this.validInput = false;
          return;
        }
      }
      this.validInput = true;
    },
    updateValue() {
      if (!this.validInput) return;
      this.$emit('update:value', this.intValue);
    }
  },
  computed: {
    placeholder() {
      return `2${this.daysLetter} 6${this.hoursLetter} 15${this.minutesLetter} 30${this.secondsLetter}`;
    },
    intValue() {
      let splitted = this.stringInput.trim().split(" ");
      var obj = Duration.fromObject({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      for (var i = 0; i < splitted.length; i++) {
        let part = splitted[i];
        if (part.length > 1) {
          let unit = part[part.length - 1];
          let partValue = parseInt(part.substring(0, part.length - 1));
          if (partValue !== undefined && /^\d+$/.test(part.substring(0, part.length - 1))) {
            if (unit === this.daysLetter) {
              obj = obj.set({ days: obj.days + partValue });
            } else if (unit === this.hoursLetter) {
              obj = obj.set({ hours: obj.hours + partValue });
            } else if (unit === this.minutesLetter) {
              obj = obj.set({ minutes: obj.minutes + partValue });
            } else if (unit === this.secondsLetter) {
              obj = obj.set({ seconds: obj.seconds + partValue });
            }
          }
        }
      }
      return obj.normalize().as("seconds");
    },
    stringValue() {
      const normalized = Duration.fromObject({ days: 0, hours: 0, minutes: 0, seconds: this.value }).normalize();
      const newValue = [];
      if (normalized.days > 0) newValue.push(normalized.days + this.daysLetter);
      if (normalized.hours > 0) newValue.push(normalized.hours + this.hoursLetter);
      if (normalized.minutes > 0) newValue.push(normalized.minutes + this.minutesLetter);
      if (normalized.seconds > 0) newValue.push(normalized.seconds + this.secondsLetter);
      return newValue.join(" ");
    },
    displayValue() {
      if (!this.validInput) return undefined;
      return utilities.formatDuration(this.value);
    }
  }
}
</script>
